export default __webpack_public_path__ + "static/media/wow.a97e7f79.png";